import type { RefOrGetter } from "ls/common/types";
import type { UrlMetadata } from "../disko/api/urlMetadata.types";
import { computed, toValue } from "vue";

export function useMetadataDetails(metadata: RefOrGetter<UrlMetadata | undefined>) {
  const faviconSrc = computed(() => {
    const metadataValue = toValue(metadata);
    if (!metadataValue) {
      return undefined;
    }

    const meta = metadataValue.meta;
    if (meta && meta.faviconUrl) {
      return meta.faviconUrl;
    }

    const faviconImage = metadataValue.faviconImage;
    if (faviconImage) {
      return `data:image/png;base64,${faviconImage.data}`;
    }

    return undefined;
  });

  return {
    faviconSrc,
  };
}
